import React from "react";

function AdminServices() {
  return <div>Admin Services Page</div>;
}

export default AdminServices;
